
import { defineComponent, SetupContext, PropType, ref } from "vue";
import NativeClient from "@/client/native-client";
import SearchTagList from "@/components/search/SearchTagList.vue";
import { TagGroupInfo } from "@/types/search";
export default defineComponent({
  name: "PantrySearchDialog",
  components: {
    SearchTagList
  },
  props: {
    /**
     * ダイアログのアクティブ状態 (true: 活性、false: 非活性)
     */
    isShowDialog: {
      type: Boolean,
      default: false
    },
    tagGroupsInfo: {
      type: Array as PropType<TagGroupInfo[]>,
      default: () => null
    },
  },
  setup(props, context: SetupContext) {
    const isTargetAll = ref(true);
    const onClickClose = () => {
      context.emit("click-close");
      isTargetAll.value = true;
    };
    const setTag = (alias: string, id: number) => {
      context.emit("select-tag", alias, id);
    };
    const onClickSetting = () => {
      context.emit("click-setting", isTargetAll.value);
      isTargetAll.value = true;
    };
    const getRadioImage = (check: boolean) => {
      return (check) ? require("@/assets/images/radio_on.png") : require("@/assets/images/radio_off.png");
    };
    const getRadioAll = () => {
      return getRadioImage(isTargetAll.value);
    };
    const getRadioPantry = () => {
      return getRadioImage(!isTargetAll.value);
    };
    const onClickRadioAll = () => {
      isTargetAll.value = true;
    };
    const onClickRadioPantry = () => {
      isTargetAll.value = false;
    };
    return {
      onClickClose,
      setTag,
      onClickSetting,
      getRadioAll,
      getRadioPantry,
      onClickRadioAll,
      onClickRadioPantry,
      isTargetAll
    };
  }
});
